import React from 'react';
import { useSelector } from 'react-redux';

//Components
import { Switch, Route, Redirect } from 'react-router-dom';

//Routes
import Success from '../Success/Success';
import Booking from '../Booking/Booking';
import Confirm from '../Confirm/Confirm';

import { ROUTER_PATH } from '../../../../const/ROUTER_PATH';
import { ROUTER_URL } from '../../../../const/ROUTER_URL';

const Book = () => {
    const shopId = useSelector(state => state.companies.shopId);

    return (
        <Switch>
            <Route
                path={ROUTER_PATH.BOOK_SUCCESS_TYPE}
                component={Success}
            />
            <Route
                path={ROUTER_PATH.BOOK}
                exact
                component={Booking}
            />
            <Route
                path={ROUTER_PATH.BOOK_CONFIRM_TYPE}
                component={Confirm}
            />

            <Redirect to={ROUTER_URL.SHOPS_ID({ shopId })} />
        </Switch>
    );
};

export default Book
